import { render, staticRenderFns } from "./corporate-training.vue?vue&type=template&id=fba7367e&scoped=true&"
import script from "./corporate-training.vue?vue&type=script&lang=js&"
export * from "./corporate-training.vue?vue&type=script&lang=js&"
import style0 from "./corporate-training.vue?vue&type=style&index=0&id=fba7367e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba7367e",
  null
  
)

export default component.exports